const config = {
    "Group": {
        "EAP1": 357,
        "EAP2": 391,
        "EAP3": 349,
        "TopUpPercent1": 0.112639,
        "TopUpPercent2": 0.112639,
        "TopUpPercent3": 0.112639
    }
}

export default config;